import firebase from './firebaseBundle'

const initializeFirebase = async () => {
  let config
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'load-balancer'
  ) {
    config = {
      apiKey: 'AIzaSyD3zGHMnA7D7wv9tK5pS7pspWshGBTcFAI',
      authDomain: 'anova-app-staging-8068f.firebaseapp.com',
      databaseURL: 'https://anova-app-staging-8068f.firebaseio.com',
      projectId: 'anova-app-staging-8068f',
      storageBucket: '',
      messagingSenderId: '560607396239'
    }
  } else {
    config = {
      apiKey: 'AIzaSyB0VNqmJVAeR1fn_NbqqhwSytyMOZ_JO9c',
      authDomain: 'anova-app.firebaseapp.com',
      databaseURL: 'https://anova-app.firebaseio.com',
      projectId: 'anova-app',
      storageBucket: 'anova-app.appspot.com',
      messagingSenderId: '322173998509'
    }
  }

  firebase.initializeApp(config)

  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE)
}

export default initializeFirebase
